import { ReactComponent as AppRole } from './appRoles.svg'

export default AppRole
